import toast from 'react-hot-toast';
import {
    URL_BACKEND,
    URL_EXPEDIENTE_REPORTES_ENVIADOS_POR_CORREO
} from '../../api/url';


const useExpendienteReportesEnviadosPorCorreo = () => {

    const expedienteTodosReportesEnviados = (id_carrera, nom_carrera) => {

        //obtener la información necesaria de todos los aspirantes
        // alerta de que se va a descargar el reporte
        toast('Generando reporte', {
            icon: '⌛',
            style: {
                borderRadius: '10px',
                background: '#333',
                color: '#fff',
            }
        });

        let data = new FormData();
        data.append("funcion", "reporteGeneralAlumnos");
        data.append("pk_carrera", 0);

        fetch(URL_BACKEND, {
            method: "POST",
            body: data
        })
        .then(res => res.json())
        .then(datos => {

            //filtro de aspirantes por carrera

            let aspirantesEnviados = [];

            aspirantesEnviados = datos.filter((aspirante) => {
                if (aspirante.fk_carrera == id_carrera) {
                    return true;
                }
            });

            // console.log(aspirantesEnviados);

            let data = new FormData();
            data.append("aspirantesEnviados", JSON.stringify(aspirantesEnviados));

            fetch(URL_EXPEDIENTE_REPORTES_ENVIADOS_POR_CORREO, {
                method: "POST",
                body: data
            })
            .then(r => r.blob())
            .then(d => {

                let nombreCarrera = nom_carrera.toUpperCase();

                const nombrePDF = "EXPEDIENTE REPORTES INDIVIDUALES ENVIADOS POR CORREO A ASPIRANTES - " + nombreCarrera;

                let pdf = URL.createObjectURL(d);
                // window.open(pdf, "_blank");
                var anchor = document.createElement("a");
                anchor.download = nombrePDF;
                anchor.href = pdf;
                anchor.click();

            })
            .catch(() => alert("Error al generar reporte"));


        })
        .catch(() => { alert("Error en el servidor"); });

    }


    return {
        expedienteTodosReportesEnviados
    }

}

export default useExpendienteReportesEnviadosPorCorreo;;